import { ENV_CONFIG, PATH } from '../../config';

const params = {
  sentryUrl: ENV_CONFIG.RICHARTLIFE_SENTRY_URL,
  uid: ENV_CONFIG.RICHARTLIFE_UID,
  ga: ENV_CONFIG.RICHARTLIFE_GA,
  mqtt: true,
  supportPass: true,
  supportBarcodePayment: true,
  supportService: ['parking', 'on-street-parking'],
  routes: {
    loginFlow: {
      welcomeNext: PATH.USER_LOGIN,
    },
  },
  bottomTabs: [],
  welcome: {
    laterButton: true,
    clearAuth: false,
  },
  main: {
    featureListBottom: ['coupon', 'promotions', 'contact'],
    settingButton: true,
  },
  setting: {
    logout: true,
  },
  licensePlates: {
    helpButton: false,
    addPlate: false,
    dialog: [
      'rebind-taipei-city-parking',
      'rebind-on-street-parking',
      'cancel',
    ],
  },
  promotions: ['ParkingPromotion', 'OnStreetParkingPromotion'],
  autopay: {
    searchBills: false,
  },
};

export default params;
